//eslint:disable max-func-body-length
import { toISODatewithoutTimezone } from 'app/infrastructure/data/date';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { CodeItemWire, CodeToWire } from '../types';

export const mapCodeToWire = (codeToWire: CodeToWire): CodeItemWire => {

  const { codeItem } = codeToWire;

  return {
    ...(!!codeItem.validFrom && {
      validFrom: toISODatewithoutTimezone(codeItem.validFrom)()
    }),

    ...(!!codeItem.substanceCategory && {
      substanceCategory: {
        v: codeItem.substanceCategory.value
      }
    }),
    ...(!!codeItem.substance && {
      substance: {
        v: codeItem.substance.value
      }
    }),
    ...(!!codeItem.substanceUom && {
      substanceUom: {
        v: codeItem.substanceUom.value
      }
    }),
    ...(!!codeItem.indicatorSubstanceCategory && {
      indicatorSubstanceCategory: {
        v: codeItem.indicatorSubstanceCategory.value
      }
    }),
    ...(!!codeItem.indicatorSubstance && {
      indicatorSubstance: {
        v: codeItem.indicatorSubstance.value
      }
    }),
    ...(!!codeItem.indicatorSubstanceUom && {
      indicatorSubstanceUom: {
        v: codeItem.indicatorSubstanceUom.value
      }
    }),
    ...(!!codeItem.indicatorType && {
      indicatorType: {
        v: codeItem.indicatorType.value
      }
    }),
    location: {
      v: !!codeItem.location ? codeItem.location.value : 0
    },
    unit: {
      v: !!codeItem.unit ? codeItem.unit.value : 0
    },
    source: {
      v: !!codeItem.source ? codeItem.source.value : 0
    },
    equipment: {
      v: !!codeItem.equipment ? codeItem.equipment.value : 0
    },
    ...(isDefinedIncludingZero(codeItem.factor) && {
      factor: codeItem.factor
    })
  };
};
